import { render, staticRenderFns } from "./EditReport.vue?vue&type=template&id=20d1424c&scoped=true"
import script from "./EditReport.vue?vue&type=script&lang=js"
export * from "./EditReport.vue?vue&type=script&lang=js"
import style0 from "./EditReport.vue?vue&type=style&index=0&id=20d1424c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d1424c",
  null
  
)

export default component.exports